export const PER_PAGE_FIRST = 9;
export const PER_PAGE_REST = 10;

export const getPageOffset = (pageNo: number) => {
  let offset = 0;
  pageNo = Number(pageNo);

  if (1 === pageNo) {
    offset = 0;
  } else if (2 === pageNo) {
    offset = PER_PAGE_FIRST;
  } else {
    offset = PER_PAGE_FIRST + (pageNo - 2) * PER_PAGE_REST;
  }
  return offset;
};

export const calcPageCountFromPostCount = (totalPostCount: number) => {
  return Math.ceil((totalPostCount - PER_PAGE_FIRST) / PER_PAGE_REST + 1);
};

export const createPaginationLinks = (
  currentPage: number,
  totalPages: number
) => {
  const paginationArray: any[] = [];
  let countOfDotItems = 0;

  if (!totalPages && 1 >= totalPages) {
    return paginationArray;
  }

  if (0 < currentPage - 2) {
    paginationArray.push(currentPage - 2);
  }

  if (0 < currentPage - 1) {
    paginationArray.push(currentPage - 1);
  }

  paginationArray.push(currentPage);

  if (totalPages >= currentPage + 1) {
    paginationArray.push(currentPage + 1);
  }

  if (totalPages >= currentPage + 2) {
    paginationArray.push(currentPage + 2);
  }

  if (1 < paginationArray[0] - 1) {
    paginationArray.unshift('...');
    countOfDotItems += 1;
  }

  if (
    2 <
    totalPages - paginationArray[paginationArray.length - (2 - countOfDotItems)]
  ) {
    paginationArray.push('...');
  }

  if (-1 === paginationArray.indexOf(1)) {
    paginationArray.unshift(1);
  }

  if (-1 === paginationArray.indexOf(totalPages)) {
    paginationArray.push(totalPages);
  }

  return paginationArray;
};

export default createPaginationLinks;
